import type { InvoiceFlow, UserInvoiceFilters } from '../../../../lib/userInvoicesApi';
import { Select } from '../../../ui/Select';
import { DateField } from '../../../ui/DateField';

interface UnifiedInvoicesFiltersProps {
  filters: UserInvoiceFilters;
  // Distinct category labels present in the current result set, for the
  // category dropdown. Derived client-side from the loaded rows.
  categories: string[];
  // Distinct status labels present in the current result set. Sources use
  // different status vocabularies (SmartBill payment status vs Invoice status),
  // so we surface whatever actually appears rather than a hard-coded list.
  statuses: string[];
  onChange: (patch: Partial<UserInvoiceFilters>) => void;
  onClear: () => void;
}

const TYPES: InvoiceFlow[] = ['income', 'outcome'];

export function UnifiedInvoicesFilters({
  filters,
  categories,
  statuses,
  onChange,
  onClear,
}: UnifiedInvoicesFiltersProps) {
  return (
    <div className="grid grid-cols-2 items-end gap-3 rounded-lg border border-gray-200 bg-white p-4 sm:flex sm:flex-wrap">
      <div className="w-full sm:w-40">
        <Select
          label="Tip"
          clearable
          value={filters.type ?? ''}
          onChange={(v) => onChange({ type: v ? (v as InvoiceFlow) : undefined })}
          placeholder="Toate"
          options={TYPES.map((t) => ({
            value: t,
            label: t === 'income' ? 'Venituri' : 'Cheltuieli',
          }))}
          className="w-full"
        />
      </div>

      <div className="w-full sm:w-40">
        <Select
          label="Status"
          clearable
          value={filters.status ?? ''}
          onChange={(v) => onChange({ status: v || undefined })}
          placeholder="Toate"
          options={statuses.map((s) => ({ value: s, label: s }))}
          className="w-full"
        />
      </div>

      <div className="w-full sm:w-40">
        <Select
          label="Categorie"
          clearable
          value={filters.category ?? ''}
          onChange={(v) => onChange({ category: v || undefined })}
          placeholder="Toate"
          options={categories.map((c) => ({ value: c, label: c }))}
          className="w-full"
        />
      </div>

      <label className="flex flex-col text-xs font-medium text-gray-600">
        Emise de la
        <DateField
          value={filters.dateFrom ?? ''}
          onChange={(v) => onChange({ dateFrom: v || undefined })}
          className="mt-1 sm:w-40"
        />
      </label>

      <label className="flex flex-col text-xs font-medium text-gray-600">
        Emise până la
        <DateField
          value={filters.dateTo ?? ''}
          onChange={(v) => onChange({ dateTo: v || undefined })}
          className="mt-1 sm:w-40"
        />
      </label>

      <button type="button" onClick={onClear} className="ui-btn-secondary col-span-2 sm:col-span-1">
        Șterge filtrele
      </button>
    </div>
  );
}
